module.exports = __webpack_public_path__ + "static/media/123.e76393b3.jpg";